// if: lines of code > 300
// then: breakdown this file and move to src/features/Form/constants folder

export const CHANGE_STATE_KEY = "change_state";
export const CHANGE_STATES = { unchanged: 0, updated: 1, added: 2, deleted: 3 };

export const INPPUT_PROPS = {
  phone: "phone",
};
